import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Landing.css';

export const Landing = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const isGerman = i18n.language === 'de';

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              {isGerman 
                ? 'Willkommen bei dem MPG Versandzentrum'
                : 'Welcome to the MPG Shipping Center'
              }
            </h1>
            <p className="hero-subtitle">
              {isGerman
                ? 'Verwalten Sie Ihre Versandadresse einfach und sicher'
                : 'Manage your shipping address easily and securely'
              }
            </p>
            <div className="hero-buttons">
              <button 
                onClick={() => navigate('/register')} 
                className="hero-button primary"
                data-testid="hero-register-button"
              >
                {isGerman ? 'Registrieren' : 'Register'}
              </button>
              <button 
                onClick={() => navigate('/login')} 
                className="hero-button secondary"
                data-testid="hero-login-button"
              >
                {isGerman ? 'Anmelden' : 'Login'}
              </button>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="globe-container">
              <div className="earth-globe">
                <div className="globe-sphere">
                  <div className="continents"></div>
                  <div className="globe-shadow"></div>
                  <div className="globe-highlight"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
